import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiGlobe, FiShield, FiSlash, FiList, FiCheckCircle, FiAlertCircle, FiSearch, FiFilter, FiActivity, FiArrowRight, FiInfo } = FiIcons;
import { mockDomainIdentities, mockSuppressions, mockEventLogs } from '../data/mockData';

const Deliverability = () => {
  const [activeTab, setActiveTab] = useState('domains');
  return (
    <div className="space-y-6 animate-in fade-in duration-700">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-slate-800">Deliverability Centre</h2>
          <p className="text-sm text-slate-500">Sender identities, domain verification and suppression management.</p>
        </div>
        <div className="flex bg-white p-1 rounded-xl border border-slate-200 shadow-sm">
          {['domains', 'suppressions', 'events'].map(tab => (
            <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-1.5 rounded-lg text-xs font-bold transition-all capitalize ${activeTab === tab ? 'bg-slate-900 text-white shadow-md' : 'text-slate-500 hover:text-slate-800'}`} >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex items-start gap-4">
        <SafeIcon icon={FiInfo} className="text-blue-500 text-xl shrink-0 mt-0.5" />
        <div className="space-y-1">
          <p className="text-xs text-blue-800 leading-relaxed font-medium">
            <b>Frontend-Only Preview:</b> Deliverability event streaming is currently mock-only. Real-time provider webhook integration will be enabled after backend deployment.
          </p>
        </div>
      </div>

      {activeTab === 'domains' && (
        <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-slate-50 text-[10px] uppercase text-slate-500 font-bold border-b border-slate-100">
                  <th className="px-6 py-4">Sender Domain</th>
                  <th className="px-6 py-4">Client</th>
                  <th className="px-6 py-4 text-center">SPF</th>
                  <th className="px-6 py-4 text-center">DKIM</th>
                  <th className="px-6 py-4 text-center">DMARC</th>
                  <th className="px-6 py-4">Status</th>
                </tr>
              </thead>
              <tbody className="text-sm divide-y divide-slate-50">
                {mockDomainIdentities.map(domain => (
                  <tr key={domain.domain} className="hover:bg-slate-50 transition-colors">
                    <td className="px-6 py-4">
                      <p className="font-bold text-slate-800">{domain.domain}</p>
                      <p className="text-[10px] text-slate-500 italic">{domain.from}</p>
                    </td>
                    <td className="px-6 py-4 text-slate-600">{domain.client}</td>
                    <td className="px-6 py-4 text-center text-emerald-600 font-bold text-xs">{domain.spf}</td>
                    <td className="px-6 py-4 text-center text-emerald-600 font-bold text-xs">{domain.dkim}</td>
                    <td className="px-6 py-4 text-center text-emerald-600 font-bold text-xs">{domain.dmarc}</td>
                    <td className="px-6 py-4">
                      <span className="px-2 py-0.5 rounded text-[10px] font-bold uppercase bg-emerald-50 text-emerald-700 border border-emerald-100">
                        {domain.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      
      {activeTab === 'suppressions' && (
        <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-slate-50 text-[10px] uppercase text-slate-500 font-bold border-b border-slate-100">
                <th className="px-6 py-4">Suppressed Email</th>
                <th className="px-6 py-4">Reason</th>
                <th className="px-6 py-4">Date Added</th>
              </tr>
            </thead>
            <tbody className="text-sm divide-y divide-slate-50">
              {mockSuppressions.map(item => (
                <tr key={item.email} className="hover:bg-slate-50 transition-colors">
                  <td className="px-6 py-4 font-bold text-slate-800">{item.email}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${item.reason === 'Bounced' ? 'bg-amber-50 text-amber-700' : 'bg-red-50 text-red-700'}`}>
                      {item.reason}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-slate-500 text-xs">{item.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Deliverability;